export default __webpack_public_path__ + "static/media/testing-2k.f08d8c1a.jpg";